export const API_ENDPOINT = import.meta.env.VITE_APP_API_ENDPOINT
export const TARGET = import.meta.env.VITE_APP_TARGET
export const ALLOW_FACEBOOK_SIGNIN = true
